const SLOW_CONTROL_STEP = 0.01;
const SLOW_CONTROL_RANGE_SPAN = 0.4;
export const SLOW_CONTROL_STEP_COUNT =
  SLOW_CONTROL_RANGE_SPAN / SLOW_CONTROL_STEP + 1;

export const REVERB_AMOUNT_STEP = 1 / (SLOW_CONTROL_STEP_COUNT * 2 - 1);

const REVERB_AMOUNT_ANCHORS = [
  { value: 0, label: "None" },
  { value: 0.15, label: "Hint" },
  { value: 0.3, label: "Light" },
  { value: 0.45, label: "Soft" },
  { value: 0.6, label: "Med" },
  { value: 0.75, label: "Lush" },
  { value: 0.9, label: "Deep" },
  { value: 1, label: "Wash" },
];

const REVERB_PRESET_RADIUS_STEPS = 2;

function buildReverbPresetZones(step, anchors, radiusSteps) {
  const stepCount = Math.round(1 / step) + 1;

  return anchors.map((anchor) => {
    const centerIndex = Math.round(anchor.value / step);
    return {
      ...anchor,
      centerIndex,
      minIndex: Math.max(0, centerIndex - radiusSteps),
      maxIndex: Math.min(stepCount - 1, centerIndex + radiusSteps),
    };
  });
}

export function reverbPresetForStepIndex(index, presetZones) {
  return presetZones.find(
    (zone) => index >= zone.minIndex && index <= zone.maxIndex,
  );
}

function buildReverbAmountSteps(step, presetZones) {
  const stepCount = Math.round(1 / step) + 1;
  const range = Array.from({ length: stepCount }, (_, i) =>
    parseFloat((i * step).toFixed(4)),
  );

  return range.map((value, i) => {
    const preset = reverbPresetForStepIndex(i, presetZones);
    return {
      value,
      label: preset ? preset.label : value.toFixed(2),
    };
  });
}

export const REVERB_PRESET_ZONES = buildReverbPresetZones(
  REVERB_AMOUNT_STEP,
  REVERB_AMOUNT_ANCHORS,
  REVERB_PRESET_RADIUS_STEPS,
);

export const REVERB_AMOUNT_STEPS = buildReverbAmountSteps(
  REVERB_AMOUNT_STEP,
  REVERB_PRESET_ZONES,
);
